import { useAuth } from "@/context/AuthContext";
import { Eye } from "lucide-react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const impersonating = !!user?.imp_by_email || localStorage.getItem("stockly_impersonating") === "1";

  if (!impersonating) return null;

  const stop = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("stockly_impersonating");
    await logout();
    toast.success("Impersonatie gestopt — log opnieuw in");
    nav("/login");
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between gap-3 text-sm font-medium" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 min-w-0">
        <Eye size={16} className="shrink-0" />
        <span className="truncate">
          Je werkt nu als <b>{user?.name || user?.email}</b> · alle acties worden gelogd.
        </span>
      </div>
      <button onClick={stop} className="shrink-0 px-3 h-7 bg-white/20 hover:bg-white/30 rounded-md text-xs font-semibold" data-testid="stop-impersonation">
        Stop impersonatie
      </button>
    </div>
  );
}
